import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import ClientManagerService from '../services/ClientManager/clientManager.service';

export const usePaymentGroups = () => {
  const { getPaymentGroups } = ClientManagerService();
  const { data, isLoading, isLoadingError } = useQuery(getPaymentGroups());

  // Memoised: the picker's option list derives from this array.
  const paymentGroups = useMemo(() => data ?? [], [data]);

  return {
    paymentGroups,
    isLoadingPaymentGroups: isLoading,
    isPaymentGroupsLoadingError: isLoadingError,
  };
};
